import { SearchIcon } from "@chakra-ui/icons";
import {
  Avatar,
  Box,
  Flex,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import { BellIconButton, TopHeaderContainer, UserSearch } from "./style";
import NotificationBell from "@root/assets/icons/bell";
import { useTranslation } from "react-i18next";

export const TopHeader: React.FC<TopHeaderProps> = ({
  profilePic,
  onBellClick,
  onSearch,
  name,
  hidden,   // 👈 added
}) => {
  const { t } = useTranslation("common");

  if (hidden) return null; // 👈 don’t render if hidden is true

  return (
    <TopHeaderContainer justify="space-between">
      {/* Search Input */}
      <Box maxW="400px" flex="1">
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="#5C6670" pt="1" boxSize={5} />
          </InputLeftElement>

          <UserSearch
            _placeholder={{
              color: "#000000",
              fontSize: "14px",
              fontWeight: "500",
            }}
            placeholder={t("dashboard.search")}
            onChange={(e) => onSearch?.(e.target.value)}
          />

          <InputRightElement width="4.5rem">
            <Text fontSize="sm" color="gray.500">
              ⌘ K
            </Text>
          </InputRightElement>
        </InputGroup>
      </Box>

      {/* Right Icons */}
      <Flex align="center" gap={4} ml={4}>
        <BellIconButton
          aria-label="Notifications"
          icon={<NotificationBell />}
          onClick={onBellClick}
        />
        <Avatar
          size="sm"
          name={name}
          src={profilePic || "https://bit.ly/broken-link"}
        />
      </Flex>
    </TopHeaderContainer>
  );
};
